// ResponseContext.js
import React, { createContext, useState } from 'react';

export const ResponseContext = createContext();

export function ResponseProvider({ children }) {
  const [responseContent, setResponseContent] = useState(null);

  return (
    <ResponseContext.Provider value={{ responseContent, setResponseContent }}>
      {children}
    </ResponseContext.Provider>
  );
}